import { createReducer } from 'redux-create-reducer'
import { CLIENT_LIBRARY_LIST_CREATE_FAIL } from '@disco/constants/ActionTypes'
export type State = {
  errors: Record<string, string | string[]> | null | undefined
}
const initialState: State = {
  errors: null,
}
export const listReducer = createReducer<State, any>(initialState, {
  [CLIENT_LIBRARY_LIST_CREATE_FAIL](state, action) {
    return { ...state, errors: action.error }
  },
})
